import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n                    <div class=", " ref=", ">", "</div>   \n                "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <a href=", " class=", ">\n                ", "\n            </a>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import store from 'lib/store';
import { ref } from 'lib/lit-ref';
import anime from 'animejs';
import * as styles from './styles';

const mediator = require('tiny-emitter/instance');

export default class Logo extends Component {
  init() {
    this.isVisible = false;
  }

  render() {
    let text = store.get('content').logotype.split(' ');
    return html(_templateObject(), ENV.baseURL, styles.link, text.map(word => html(_templateObject2(), styles.word, ref(this, 'words'), word)));
  }

  onRender() {
    this.classList.add(styles.logo);
    this.classList.add('u-hidden');
    mediator.on('route', this.onRoute, this);
  }

  onResize(width, height) {}

  onRoute() {
    if (!this.isVisible) this.enter();
  }

  animateIn(params, complete) {
    this.isVisible = true;
    anime({
      targets: this.refs.words,
      opacity: [0, 1],
      skewY: [7, 0],
      translateY: [20, 0],
      easing: 'easeOutQuint',
      duration: 1000,
      delay: anime.stagger(80, {
        start: 1800
      }),
      begin: () => {
        this.classList.remove('u-hidden');
      },
      complete
    });
  }

  animateOut(params, complete) {
    complete && complete();
  }

  onDestroy() {}

}
customElements.define('rv-logo', Logo);